/**
 *  called when clicked on social pay
 */
export const HANDLE_SET_SOCIAL_PAY_PLATFORM = 'HANDLE_SET_SOCIAL_PAY_PLATFORM';
export function handleSetSocialPayPlatform (platform) {
  return {
    type: HANDLE_SET_SOCIAL_PAY_PLATFORM,
    payload: {
      platform,
    },
  };
}

/**
 *
 * TODO
 * it's possible for someone to social auth once,
 * then go back to first step and do some changes,
 * then go to twitter's authed apps and remove Instamojo,
 * then click on pay with tweet again.
 * then close the popup modal
 * and she would see the FinalizeSocialPay View open. :)
 * I think nobody (except a tester) would do this.
 * So I'll leave this to the day when a bug report comes in from customer.
 */

import root from 'window-or-global';
import { camelCaseKeys } from 'config/utils';
export const HANDLE_SOCIALPAY_AUTH_CALLBACK = 'HANDLE_SOCIALPAY_AUTH_CALLBACK';
export function handleSetupSocialPayAuthCallbackListener () {
  return dispatch => {
    const interval = setInterval(() => {
      if (root.socialPayCallbackData) {
        const { socialPayCallbackData } = window;
        dispatch({
          type: HANDLE_SOCIALPAY_AUTH_CALLBACK,
          payload: {
            socialPayCallbackData: camelCaseKeys(socialPayCallbackData),
          },
        });
        clearInterval(interval);
      }
    }, 500);
  };
}


export const HANDLE_SET_LOADING_SOCIAL_PAY_PLATFORM = 'HANDLE_SET_LOADING_SOCIAL_PAY_PLATFORM';
export const HANDLE_REMOVE_LOADING_SOCIAL_PAY_PLATFORM = 'HANDLE_REMOVE_LOADING_SOCIAL_PAY_PLATFORM';
export function handleSetupCloseSocialPayAuthWindowBeforeAuthListener (selectedSocialPayPlatform) {
  return (dispatch, getState) => {
    dispatch({
      type: HANDLE_SET_LOADING_SOCIAL_PAY_PLATFORM,
      payload: {
        selectedSocialPayPlatform,
      },
    });

    const interval = setInterval(() => {
      /* globals windows */
      if (windows[selectedSocialPayPlatform] && windows[selectedSocialPayPlatform].closed && getState().socialPay.loading[selectedSocialPayPlatform]) {
        windows[selectedSocialPayPlatform] = null;
        dispatch(handleSetSocialPayPlatform(null));
        dispatch({
          type: HANDLE_REMOVE_LOADING_SOCIAL_PAY_PLATFORM,
          payload: {
            selectedSocialPayPlatform,
          },
        });
        clearInterval(interval);
      }
    }, 500);
  };
}



// WEBPACK FOOTER //
// ./src/payments/actions/SocialPayActions.js